import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

export interface ExtScorecardListPopupItem {
    userId: number;
    userName: string;
    scorecardID: number;
    scorecardName: string;
    points: number;
    myRank: number;
    maxRank: number;
    bandID: number;
    band: string;
    periodType: number;
    startDate: string;
    endDate: string;
    width: number;
}

export interface ScorecardListPopupItem {
    userId: number;
    username: string;
    scorecardId: number;
    scorecardName: string;
    points: number;
    rank: string;
    bandName: string;
    startDate: Date;
    endDate: Date;
}

export interface ScorecardListPopup {
    items: ScorecardListPopupItem[];
}

class ScorecardListPopupItemModelTransformer
    implements
        ModelTransformer<ScorecardListPopupItem, ExtScorecardListPopupItem>
{
    transform(model: ExtScorecardListPopupItem): ScorecardListPopupItem {
        return {
            userId: model.userId,
            username: model.userName,
            scorecardId: model.scorecardID,
            scorecardName: model.scorecardName,
            points: model.points,
            rank: `${model.myRank}/${model.maxRank}`,
            bandName: model.band,
            startDate: Util.dateToDate(model.startDate),
            endDate: Util.dateToDate(model.endDate),
        };
    }
}

class ScorecardListPopupItemModelSetTransformer extends ModelSetTransformer<
    ScorecardListPopupItem,
    ExtScorecardListPopupItem
> {
    protected newTransformer(): ModelTransformer<
        ScorecardListPopupItem,
        ExtScorecardListPopupItem
    > {
        return new ScorecardListPopupItemModelTransformer();
    }
}

export class ScorecardListPopupModelTransformer
    implements
        ModelTransformer<ScorecardListPopup, ExtScorecardListPopupItem[]>
{
    transform(model: ExtScorecardListPopupItem[]): ScorecardListPopup {
        const items = new ScorecardListPopupItemModelSetTransformer().transform(
            model,
        );
        return {
            items,
        };
    }
}

export function validateScorecardListPopup(model: ScorecardListPopup): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('ScorecardListPopup not valid');
    }
}
